import {
    useAppInsightsContext,
    useTrackEvent,
} from '@microsoft/applicationinsights-react-js';
import { Trans, useTranslation } from 'react-i18next';

import { Body1, Checkbox } from '@myphx-engineering/phx-design-system';
import type { UseFormReturnType } from '@myphx-engineering/phx-design-system/hooks';

import { CONSTANTS } from '../../constants';
import { PolicyTextButton } from '../policy-links';

export type FormWithLillyCheckbox = {
    lillyTermsAccepted: boolean;
};

export type LillySigninTermsCheckboxProps = {
    form: UseFormReturnType<FormWithLillyCheckbox>;
};

export const LillyTermsCheckbox = ({ form }: LillySigninTermsCheckboxProps) => {
    const { t } = useTranslation();
    const appInsights = useAppInsightsContext();
    const track = useTrackEvent(appInsights, 'lillyTermsAccepted_CLICK', {});

    const privacyText = t('lilly.privacy');
    const termsConditionsText = t('lilly.terms');

    const policyCheckboxLabel = (
        <Body1>
            <Trans
                i18nKey="lilly.signInPage.termsOptIn"
                components={{
                    1: (
                        <PolicyTextButton
                            linkText={termsConditionsText}
                            linkType={CONSTANTS.lillyTermsOfUseLink}
                            eventName="LILLY-T&C"
                        />
                    ),
                    2: (
                        <PolicyTextButton
                            linkText={privacyText}
                            linkType={CONSTANTS.lillyPrivacyStatementLink}
                            eventName="LILLY-PRIVACY"
                        />
                    ),
                }}
            />
        </Body1>
    );

    const inputProps = form.getInputProps('lillyTermsAccepted');
    inputProps.onChange = () => {
        track({ message: 'Checkbox field lillyTermsAccepted is clicked' });
        form.setFieldValue(
            'lillyTermsAccepted',
            !form.values.lillyTermsAccepted
        );
    };

    return (
        <Checkbox label={policyCheckboxLabel} {...inputProps} error={null} />
    );
};
